// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"ConfirmDuplicateCollectionModal_formGroup__Kl7Zc","modalActions":"ConfirmDuplicateCollectionModal_modalActions__3gvT-"};